module.exports = __webpack_public_path__ + "static/media/SF_bm_sekundaerlogo_postale_troendelag_pos.2f4f49e0.png";